<div class="board-column">

	<div class="column-header">
		<div class="column-title">
			Alerts
		</div>
	</div>

	<!-- <div class="tasks-container" cdkDropList [cdkDropListData]="column" (cdkDropListDropped)="onDropIn($event)"
		*libInView> -->


	<ng-container *ngIf="loadingSpinner">
		<lib-progress-spinner></lib-progress-spinner>
	</ng-container>

	<div class="tasks-container" *ngIf="!loadingSpinner">
		<div class="project-alert" *ngFor="let alert of alerts">

			<app-project-alert [projectAlert]="alert"></app-project-alert>

		</div>
	</div>
</div>